/**
 * The question a sign-in expiry interrupted (agent-1.1 S9.1, K14).
 *
 * A 401 on a send signs the person out, and the sign-out unmounts the assistant,
 * so the words they had just sent would be lost. They are kept here, in THIS TAB's
 * `sessionStorage`, under the account that typed them, and handed back to the
 * composer only when that same account is signed in again. Any other account's
 * sign-in clears them unread: per-user browser state goes with the session, as
 * `AuthContext`'s expiry rule says, so the next person never sees a stranger's words.
 *
 * Storage can be absent or refuse (a private window, blocked site data); every
 * access is guarded and a failure only means the words are not kept.
 */
const KEY = 'brainspot:assistant-draft'

export function keepInterruptedDraft(accountId: string, text: string): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ account: accountId, text }))
  } catch {
    // Not kept: the person types it again.
  }
}

/** The interrupted words if they were this account's; reads only (a render may call it twice). */
export function peekInterruptedDraft(accountId: string): string | null {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (raw === null) return null
    const kept = JSON.parse(raw) as { account?: unknown; text?: unknown }
    return kept.account === accountId && typeof kept.text === 'string' ? kept.text : null
  } catch {
    return null
  }
}

/** Forget the kept words, whoever's they were: called once the provider has read them. */
export function clearInterruptedDraft(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // Nothing to clear, or nothing we may touch.
  }
}
